import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
export const WorkflowsIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Workflows",
    children: /*#__PURE__*/_jsx("path", {
      d: "M29.24 22.68h-2.13v-4.36c0-1.33-1.08-2.41-2.42-2.42h-7.27v-3.87h.73c1.2 0 2.18-.98 2.18-2.18V5.5c0-1.2-.98-2.18-2.18-2.18h-4.38c-1.2 0-2.18.98-2.18 2.18v4.35c0 1.2.98 2.18 2.18 2.18h.72v3.87H7.25c-1.33 0-2.41 1.08-2.42 2.42v4.36H2.77c-.43.01-.78.37-.78.8 0 .15.04.28.11.4s3.58 4.41 3.58 4.41c.11.24.36.41.64.41s.52-.16.64-.4 3.58-4.41 3.58-4.41a.804.804 0 0 0-.63-1.19H7.74v-3.87H24.2v3.87h-2.1a.807.807 0 0 0-.65 1.19s3.58 4.41 3.58 4.41c.12.24.36.41.64.41s.52-.16.64-.4 3.58-4.41 3.58-4.41a.802.802 0 0 0-.66-1.19ZM14.52 9.12v-2.9h2.9v2.9z"
    })
  }));
};